import * as React from 'react';
import { Message } from '../../typedefs/store';
const debounce = require('lodash.debounce');

export interface BaseProps {
    send: (message: string) => void;
    changeTypingStatus: (status: 'composing' | 'paused') => void;
    disabled: boolean;
}

export interface BaseState {
    message: string;
    composing: boolean;
}

export const initialState = { message: '', composing: false };

export default class BaseSendForm<
    Props extends BaseProps,
    State extends BaseState
> extends React.Component<Props, State> {
    inputRef: HTMLInputElement | HTMLTextAreaElement;
    timer: any;

    constructor(props: Props) {
        super(props);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    componentDidMount() {
        if (this.inputRef) this.inputRef.focus();
    }

    handleInputChange(e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) {
        this.setState({ message: e.currentTarget.value });
        if (!this.state.composing) {
            this.setState({ composing: true });
            this.props.changeTypingStatus('composing');
        }
        // (re)start timeout
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.setState({ composing: false });
            this.props.changeTypingStatus('paused');
        }, 5000);
    }

    handleKeyDown(e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            this.send();
        }
    }

    handleButtonClick(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        e.stopPropagation();
        this.send();
    }

    send() {
        if (this.props.disabled) return;

        const message = this.state.message.trim();
        if (message !== '') this.props.send(message);
        clearTimeout(this.timer);
        this.props.changeTypingStatus('paused');
        this.setState({ message: '', composing: false });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/BaseSendForm.tsx